import { Event } from "../../types/events";
import React, { Fragment } from "react";
import * as EVENT from "./event.styles";
import * as TYPO from "../../styles/common/typo.styles";

interface DateMonthProps {
    event: Event;
}
const DateMonth: React.FC<DateMonthProps> = ({ event }) => {
	   if (event) return (
        <Fragment>
            {event.eventStartDate === event.eventEndDate && event.isSameDateMonth ? (
                <EVENT.DateView>
                    <TYPO.HeadingOne>{event?.date}</TYPO.HeadingOne>
                    <TYPO.BodyBold>{event?.month}</TYPO.BodyBold>
                </EVENT.DateView>
            ) :  <EVENT.DateView>
                <EVENT.DateViewTwo>
                    <EVENT.DateViewCol>
                        <TYPO.HeadingTwo>{event?.eventStartDate}</TYPO.HeadingTwo>
                        <TYPO.BodyBoldSm>{event.startDayMonth}</TYPO.BodyBoldSm>
                    </EVENT.DateViewCol>
                    <TYPO.HeadingTwo>-</TYPO.HeadingTwo>
                    <EVENT.DateViewCol>
                        <TYPO.HeadingTwo>{event?.eventEndDate}</TYPO.HeadingTwo>
                        <TYPO.BodyBoldSm>{event?.endDayMonth}</TYPO.BodyBoldSm>
                    </EVENT.DateViewCol>
                </EVENT.DateViewTwo>
            </EVENT.DateView>
            }
        </Fragment>
    )
    return <Fragment/>
};
export default DateMonth;